import React, { useMemo, useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Backdrop,
  Typography,
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

import Table from '../../../../components/tables/Table';
import tableStyles from '../../../../components/tables/Table.styles';
import styles from './HomeTable.styles';

function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-GB');
}

export default function HomeTable({ sortedFailures }) {
  const rows = Array.isArray(sortedFailures) ? sortedFailures : [];

  const [fullScreen, setFullScreen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => { setRefreshKey((k) => k + 1); }, [fullScreen]);

  const COLUMNS = useMemo(() => ([
    {
      label: 'Unit',
      field: 'Unit',
      type: 'string',
      sortable: true,
    },
    {
      label: 'EVN',
      field: 'EVN',
      type: 'string',
      sortable: true,
    },
    {
      label: 'Meter',
      field: 'MeterID',
      type: 'string',
      sortable: true,
    },
    {
      label: 'Status',
      field: 'Status',
      type: 'string',
      sortable: true,
    },
    {
      label: 'Error Message',
      field: 'ErrorMessage',
      type: 'string',
      sortable: true,
      render: (_row, v) => v || '—',
    },
    {
      label: 'File Name',
      field: 'FileName',
      type: 'string',
      sortable: true,
    },
    {
      label: 'Data Date',
      field: 'Data Date',
      type: 'date',
      sortable: true,
      render: (row) => {
        const v = row?.['Data Date'];
        if (!v) return '—';
        const d = new Date(v);
        if (Number.isNaN(d.getTime())) return '—';
        return d.toLocaleDateString('en-GB');
      },
    },
    {
      label: 'Date Loaded',
      field: 'DateFileLoad',
      type: 'date',
      sortable: true,
      render: (row) => formatDateTime(row?.DateFileLoad) || '—',
    },
    {
      label: 'Data Provider',
      field: 'DataProvider',
      type: 'string',
      sortable: true,
    },
  ]), []);

  return (
    <>
      {fullScreen && (
        <Backdrop open sx={{ zIndex: 1298, backdropFilter: 'blur(4px)' }} />
      )}

      <Box sx={{ ...styles.thirdCard, ...(fullScreen && styles.fullScreenCard) }}>
        <Box sx={styles.headerRow}>
          <Typography variant="subtitle2" sx={styles.headerTitle}>
            Files Failed to Load
          </Typography>
          <IconButton
            onClick={() => setFullScreen((prev) => !prev)}
            size="medium"
            sx={styles.fullScreenToggleButton}
            aria-label={fullScreen ? 'Exit full screen' : 'Enter full screen'}
          >
            {fullScreen ? (
              <CloseFullscreenIcon fontSize="small" />
            ) : (
              <OpenInFullIcon fontSize="small" />
            )}
          </IconButton>
        </Box>

        <Box sx={tableStyles.tableWrapper}>
          <Table
            key={refreshKey}
            rows={rows}
            columns={COLUMNS}
            stickyHeader
            zebra
            hover
            bordered
          />
        </Box>
      </Box>
    </>
  );
}
